import { QueryProvider } from './providers/QueryProvider';
import { AppRouter } from './routes/AppRouter';
import './styles/index.css';

export function App() {
  return (
    <QueryProvider>
      <AppRouter />
    </QueryProvider>
  );
}
